__turbopack_context__.v({
  "read-more-less": "_6ptGba_read-more-less",
  "toggle-button": "_6ptGba_toggle-button",
});
